import { AllGeoJSON, transformScale } from "src/js/util/turf";
import { Checkbox, CheckboxState } from "react-migration/components/DeprecatedCheckbox";
import { Feature, Geometry } from "geojson";

import { AnnotationSpecProps } from "./types";
import { DetailsList } from "react-migration/components/DetailsList";
import { DrawingItem } from "src/js/types/DrawingItem";
import { Polygon } from "geojson";
import { RadiusInput } from "react-migration/components/DrawingTools/RadiusInput/RadiusInput";
import { TextSwitch } from "react-migration/components/TextSwitch";
import bbox from "@turf/bbox";
import distance from "@turf/distance";
import { unitOfMeasurement } from "react-migration/lib/util/measurements";
import { updatedSelectedGeometry } from "src/js/stores/drawing/actions/updatedSelectedGeometry";
import { useSnapshot } from "valtio";
import { useState } from "react";
import { userStore } from "src/js/stores/user/store";

interface DrawingItemPoint {
  geometry: GeoJSON.Point;
}

function getRadius(drawing: DrawingItem | DrawingItemPoint | null | undefined): number {
  if (!drawing) return 0;
  const [minX, , maxX, maxY] = bbox(drawing.geometry);
  return distance([minX, maxY], [maxX, maxY], { units: "meters" }) / 2;
}

export function CircleSpec({ drawing }: AnnotationSpecProps) {
  const {
    user: {
      settings: { unit: unitPreference },
    },
  } = useSnapshot(userStore);
  const hasLabel = drawing.properties.label;
  const [smallUnitSize, setSmallUnitSize] = useState(true);

  const updateGeometry = (scale: number, drawingToScale: AllGeoJSON) => {
    const scaled = transformScale(drawingToScale, scale) as Feature<Geometry>;
    const newDrawing: DrawingItem = {
      ...drawing,
      geometry: scaled.geometry as Polygon,
    };
    updatedSelectedGeometry(newDrawing);
  };

  const onLabelToggle = (value: boolean) => {
    const newDrawing: DrawingItem = {
      ...drawing,
      properties: {
        ...drawing.properties,
        label: value,
      },
    };

    updatedSelectedGeometry(newDrawing);
  };

  const onUnitChange = (unit: string) => {
    const isSmall = unit === unitOfMeasurement({ unitPreference, small: true });
    setSmallUnitSize(isSmall);
  };

  return (
    <div className="flex flex-col gap-3">
      <DetailsList>
        <DetailsList.Item label={"Radius"}>
          <div className="flex flex-col gap-2">
            <TextSwitch name="unitScaleSizeType" value={unitOfMeasurement({ unitPreference, small: smallUnitSize })}>
              <TextSwitch.Label
                value={unitOfMeasurement({ unitPreference, small: true })}
                onToggle={onUnitChange}
                className="px-4"
              >
                {unitOfMeasurement({ unitPreference, small: true })}
              </TextSwitch.Label>
              <TextSwitch.Label
                value={unitOfMeasurement({ unitPreference, small: false })}
                onToggle={onUnitChange}
                className="px-4"
              >
                {unitOfMeasurement({ unitPreference, small: false })}
              </TextSwitch.Label>
            </TextSwitch>
            <RadiusInput
              isSmallScale={smallUnitSize}
              drawing={drawing}
              updateGeometry={updateGeometry}
              unitPreference={unitPreference}
              getRadius={getRadius}
            />
          </div>
        </DetailsList.Item>
        <DetailsList.Item label={"Show label"}>
          <Checkbox
            value={hasLabel ? CheckboxState.CHECKED : CheckboxState.EMPTY}
            onChange={(newValue) => onLabelToggle(newValue)}
          ></Checkbox>
        </DetailsList.Item>
      </DetailsList>
    </div>
  );
}
